import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Smartphone, Apple } from 'lucide-react';

const PhoneSyncTab = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Phone Contact Sync</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Sync contacts from iPhone or Android devices directly into tenant accounts.
          </p>

          <div className="grid grid-cols-2 gap-4 pt-4">
            {/* iPhone */}
            <Card>
              <CardContent className="p-6 text-center">
                <Apple className="w-12 h-12 mx-auto mb-3 text-muted-foreground" />
                <h3 className="font-semibold mb-2">iPhone Sync</h3>
                <p className="text-xs text-muted-foreground mb-4">
                  Connect via iCloud or direct USB connection
                </p>
                <Button variant="outline" disabled>
                  Coming Soon
                </Button>
              </CardContent>
            </Card>

            {/* Android */}
            <Card>
              <CardContent className="p-6 text-center">
                <Smartphone className="w-12 h-12 mx-auto mb-3 text-muted-foreground" />
                <h3 className="font-semibold mb-2">Android Sync</h3>
                <p className="text-xs text-muted-foreground mb-4">
                  Connect via Google Contacts API
                </p>
                <Button variant="outline" disabled>
                  Coming Soon
                </Button>
              </CardContent>
            </Card>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PhoneSyncTab;
